// extracted by mini-css-extract-plugin
export var block = "style-module--block--864e5";
export var image = "style-module--image--55c3e";
export var readOn = "style-module--readOn--a60f1";